import {useFormikContext} from 'formik';
import {OrderCreateRequest} from 'new-models';

export const useCheckoutFormikContext = (): ReturnType<typeof useFormikContext<OrderCreateRequest>> => {
    return useFormikContext<OrderCreateRequest>();
};
